import debounce from "lodash.debounce";
import { ChangeEventHandler, useCallback, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";

import { suggestUsername } from "~/api/auth/suggestUsername";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";
import { CreateMemberInput } from "~/types/user/user.types";

import ApplicationInput from "../../input";
import ApplicationRulesOfSilencio from "../../ruleOfSilencio";

const ApplicationStartMembership = () => {
  const { setValue, getValues, setFocus } = useFormContext<CreateMemberInput>();
  const [usernameManipulated, setUsernameManipulated] = useState(false);
  const { language } = useLanguage();
  const applyTexts =
    language === "En"
      ? englishTranslations.applyPage
      : frenchTranslations.applyPage;

  const handleSetUsername = useCallback(
    async (inputName: string) => {
      const { firstname, lastname } = getValues();
      if (!firstname || !lastname || usernameManipulated) return;
      // wait 500 ms with timeout promise
      const suggestedUsername = await suggestUsername({ firstname, lastname });
      setValue("username", suggestedUsername.data);
      setTimeout(() => {
        if (inputName === "firstname" || inputName === "lastname")
          setFocus(inputName);
      }, 10);
    },
    [getValues, setFocus, setValue, usernameManipulated]
  );

  const debouncedhandleSetUsername = useMemo(
    () => debounce(handleSetUsername, 300),
    [handleSetUsername]
  );

  const handleSetUsernameManipulated: ChangeEventHandler<
    HTMLInputElement
  > = () => {
    setUsernameManipulated(true);
  };

  return (
    <>
      <h4>{applyTexts.applicationForm.applyForMembership}</h4>
      <p>{applyTexts.applicationForm.text}</p>
      <div>
        <ApplicationInput
          register="firstname"
          placeholder={applyTexts.applicationForm.firstName}
          label={applyTexts.applicationForm.firstName}
          required={true}
          onChange={(e) => {
            debouncedhandleSetUsername(e.target.name);
          }}
        />
        <ApplicationInput
          register="lastname"
          placeholder={applyTexts.applicationForm.lastName}
          label={applyTexts.applicationForm.lastName}
          required={true}
          onChange={(e) => {
            debouncedhandleSetUsername(e.target.name);
          }}
        />
        <br />
        <ApplicationInput
          register="username"
          placeholder={applyTexts.applicationForm.username}
          label={applyTexts.applicationForm.username}
          required={true}
          onChange={handleSetUsernameManipulated}
        />
      </div>
      <div>
        <p>{applyTexts.applicationForm.confirmRules}</p>
        <ApplicationInput
          register="acceptRules"
          label="accept the rules of Silencio"
          type="checkbox"
          required={true}
        />
      </div>
      {/* <div>
        <p>Check this box to accept our Health Commitment Statement</p>
        <ApplicationInput
          register="acceptHealthStatement"
          label="accept the health statement"
          type="checkbox"
          required={true}
        />
      </div> */}

      <p>
        {language === "Fr"
          ? "En vous inscrivant, vous acceptez la"
          : "By registering, you agree to Silencio's"}{" "}
        <ApplicationRulesOfSilencio
          text={
            language === "Fr"
              ? "→ politique de confidentialité"
              : "→ Privacy Policy"
          }
        />{" "}
        {language === "Fr" ? "et les" : "and"}{" "}
        <ApplicationRulesOfSilencio
          termsOfService={true}
          text={
            language === "Fr"
              ? "→ conditions d’utilisation."
              : "→ Terms and Conditions."
          }
        />{" "}
        {applyTexts.applicationForm.changeLaterText}
      </p>

      <div>
        <p>{applyTexts.applicationForm.receiveNewsletter}</p>
        <ApplicationInput
          register="newsletters"
          label="receive updates, news and offers from Silencio and its affiliates"
          type="checkbox"
        />
      </div>
    </>
  );
};

export default ApplicationStartMembership;
